import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import { TOOLTIP_DELAY_MS, TOOLBAR_TOOLTIP_Z_INDEX, buildTooltipContent } from './utils';

interface ToolbarTooltipProps {
  title: string;
  description?: string;
  children: React.ReactElement;
}

const ToolbarTooltip = ({ title, description, children }: ToolbarTooltipProps) => (
  <Tooltip
    title={buildTooltipContent(title, description)}
    placement="bottom"
    arrow
    enterDelay={TOOLTIP_DELAY_MS}
    enterNextDelay={TOOLTIP_DELAY_MS}
    slotProps={{ tooltip: { sx: { zIndex: TOOLBAR_TOOLTIP_Z_INDEX } }, popper: { sx: { zIndex: TOOLBAR_TOOLTIP_Z_INDEX } } }}
  >
    <span>{children}</span>
  </Tooltip>
);

export default ToolbarTooltip;
